import React, { useState } from 'react'
import ModalComponent from './ModalComponent'
import axios from 'axios';
// import { embedClick } from "../utilities/script"
import "../pages/live.css"

export default function EmbedCode(props) {

    const copyFunction = (text) => {
        /* Get the text field */
        var copyText = text

        /* Select the text field */
        // copyText.select();
        // copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText);

        /* Alert the copied text */
        alert("Copied to clipboard");
    }

    return (
        <div>
            {props.showEmbedModal ?

                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="btn-close" aria-label="Close" onClick={() => props.closeModal()}></button>
                            </div>
                            <div class="modal-body">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" >Javascript <span style={{ color: "gray", fontSize: "10px" }}>( for web )</span></button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">iframe <span style={{ color: "gray", fontSize: "10px" }}>( for mobile )</span></button>
                                    </li>

                                </ul>
                                <div class="tab-content" id="myTabContent">
                                    <div class="tab-pane fade show active mt-3" id="home" role="tabpanel" aria-labelledby="home-tab">
                                        <p className="l-date">It is highly recommended that you use the javascript embed code, which provides the best user experience. </p>
                                        <div id="live-id" data-live-id={`${props.data.Id}`}></div>
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="6" value={`<div id="live-id" data-live-id=${props.data.Id}></div><script src="https://apps.mathrubhumi.com/testliveblogscript.js"></script>
                                                `}></textarea>

                                        <button className='btn l-btn mt-2' onClick={() => copyFunction(`<div id="live-id" data-live-id=${props.data.Id}></div><script src="https://apps.mathrubhumi.com/testliveblogscript.js"></script>`)}>Copy Text</button>

                                    </div>
                                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                        <div class="form-group mt-3">

                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="6" value={`https://apps.mathrubhumi.com/testliveBlog/index.html#/preview/${props.data.Id}/${props.data.event_name}`}></textarea>
                                            {/* <p><iframe name="lb24" frameborder="0" height="960px" loading="lazy" width="100%" scrolling="auto" src={`http://localhost:3000/preview/${props.data.Id}/${props.data.event_name}`}></iframe></p> */}
                                        </div>
                                        <button className='btn l-btn mt-2' onClick={() => copyFunction(`https://apps.mathrubhumi.com/testliveBlog/index.html#/preview/${props.data.Id}/${props.data.event_name}`)}>Copy Text</button>

                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                {/* <button type="button" class="btn btn-secondary" onClick={() => props.closeModal()}>Copy & Close</button> */}
                            </div>
                        </div>
                    </div>
                </ModalComponent>
                : ""}

        </div>
    )
}
